export default "__VITE_ASSET__C3mRLj5Z__"